export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10196.ee163182.jpg";